'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 29 17', width: '100%', height: '100%' },
          _react2.default.createElement(
            'g',
            { stroke: color, strokeWidth: '1.5', fill: 'none', fillRule: 'evenodd' },
            _react2.default.createElement('path', { d: 'M10.47 6.765a2.098 2.098 0 1 1-4.196-.002 2.098 2.098 0 0 1 4.196.002z' }),
            _react2.default.createElement('path', { d: 'M13.22 14.1a5.454 5.454 0 0 0-4.847-2.956 5.453 5.453 0 0 0-4.847 2.957', strokeLinecap: 'round' }),
            _react2.default.createElement('path', { d: 'M.75 8.627a7.623 7.623 0 1 1 15.246 0 7.623 7.623 0 0 1-15.246 0z', strokeLinecap: 'round' }),
            _react2.default.createElement('path', { d: 'M27.033 6.837h-6.758a.747.747 0 0 1-.747-.747V4.582c0-.413.335-.747.747-.747h6.758c.413 0 .747.334.747.747V6.09a.746.746 0 0 1-.747.747zm-7.505 3.373h6.17m-6.17 3.21h3.614', strokeLinecap: 'round', strokeLinejoin: 'round' })
          )
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Identify';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Identify.js
// module id = 1073
// module chunks = 0